import ApiService from "./api.service";
import ApiMockService from "./api.mock.service";

/**
 * SupplementService es un objeto que almacena las funciones
 *
 * getAllProducts --> función que realiza una petición ._GET al enterpoint, la cual le solicita el listado de PRODUCTOS
 * retorna el listado de prodcutos
 *
 *  getProducts --> función que realiza una petición GET al enterpoint,la cual le solicita un producto en específico
 * retorna el producto
 *
 *  getCertificationsProducts --> función que realiza una petición GET al enterpoint,la cual le solicita el listado de certificaciones de los productos
 * retorna las certificaciones
 *
 * getLabels --> función que realiza una petición GET al enterpoint,la cual le solicita el listado de etiquetas de los productos
 * retorna las etiquetas
 *
 *  getArticle --> función que realiza una petición GET al enterpoint,la cual le solicita el listado de etiquetas de los productos
 * retorna las etiquetas
 */

const ProductsService = {
  getAllProducts: async function (params) {
    const response = await ApiMockService.get("api/supplements/products", params);
    return response.data;
  },
  getProducts: async function (id, lang = null) {
    const response = await ApiMockService.get("api/supplements/products/" + id, lang);
    return response.data;
  },
  getCertificationsProducts: async function (params) {
    const response = await ApiMockService.get("api/admin/supplements/certifications-products", params);
    return response.data;
  },
  getLabels: async function (params) {
    const response = await ApiMockService.get("api/admin/supplements/labels", params);
    return response.data;
  },
  getCurrency: async function (params) {
    const response = await ApiMockService.get("api/admin/supplements/currencies", params);
    return response.data;
  },
  /* aca necesitamos armar la ruta */
  deleteGalleryPhoto: async function (photoId) {
    const response = await ApiService._get("/api/admin/food_recipe/delete-gallery-photo", { id: photoId });
    return response.data;
  },
  getFormats: async function (lang = null) {
    const response = await ApiMockService.get("api/supplements/formats", lang);
    return response.data;
  },
  getArticles: async function (lang = null) {
    const response = await ApiMockService.get("api/supplements/articles", lang);
    return response.data;
  },
};

export default ProductsService;
